import { useQuery } from "@tanstack/react-query";
import { getExtractedFilesKey } from "./queryKeys";
import api from "../services/api";
import { ExtractedFilesData } from "../modules/samples/@types";
import { IExtractedFilesQueryParams } from "./@types";

const useGetExtractedFiles = (
  hash?: string | undefined,
  qp?: IExtractedFilesQueryParams
) => {
  const shouldFetchSamples = !!hash;

  const {
    data,
    isSuccess,
    isPending: isLoading,
    isError
  } = useQuery({
    queryKey: getExtractedFilesKey(hash, qp),
    queryFn: () =>
      api.getExtractedFiles({ hashValue: hash, extractedFilesQP: qp }),
    enabled: shouldFetchSamples
  });

  return {
    extractedFileResults: data?.data?.results as ExtractedFilesData,
    isLoading: shouldFetchSamples ? isLoading : false,
    isSuccess,
    isError
  };
};

export default useGetExtractedFiles;
